import { Controller } from '@hotwired/stimulus';

// Sizes the quick-apply step's top padding to the real height of the fixed
// header (title block + collapsed job-details bar), replacing the hardcoded
// 200px fallback in the stylesheet — the header's height varies with
// viewport width and job title length.
//
// Measures on connect, window load (fonts settling can change the title's
// wrap) and resize — deliberately NOT via ResizeObserver: expanding "Show
// job detail" grows the fixed header over the content, and that overlay is
// intended, not something to pad around.
export default class extends Controller {
  static targets = ['header', 'container'];

  connect() {
    this.measure = this.measure.bind(this);
    requestAnimationFrame(this.measure);
    window.addEventListener('load', this.measure);
    window.addEventListener('resize', this.measure);
  }

  disconnect() {
    window.removeEventListener('load', this.measure);
    window.removeEventListener('resize', this.measure);
  }

  measure() {
    if (!this.hasHeaderTarget || !this.hasContainerTarget) return;

    const height = this.headerTarget.offsetHeight;
    if (height > 0) this.containerTarget.style.paddingTop = `${height}px`;
  }
}
